<template>
  <v-menu ref="menu" v-model="showCalendar" absolute offset-y style="max-width: 600px" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        :value="date"
        v-bind="attrs"
        v-on="on"
        dense
        readonly
        outlined
        class="rounded-pill w-100 text-field-styling dob-field"
        :rules="rules"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker ref="dobPicker" v-model="date" :max="max" min="1800-01-01" @change="save" scrollable></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ['value', 'label', 'rules', 'disabled'],
  data: () => ({
    showCalendar: false,
    date: '',
    max: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)
  }),

  methods: {
    save(date) {
      this.$refs.menu.save(date)
    }
  },
  watch: {
    value(val) {
      this.date = val
    },
    date(val) {
      this.$emit('input', val)
    },
    showCalendar(val) {
      val && setTimeout(() => (this.$refs.dobPicker.activePicker = 'YEAR'))
    }
  }
}
</script>
